import createLumirIcon from "../create-lumir-icon";

const Upload = createLumirIcon("Upload", [
  [
    "path",
    {
      key: "upload",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      d: "M3.875 2H16.125H16.125C16.6063 2 17 2.42353 17 2.94118V4.82353C17 5.34118 16.6063 5.76471 16.125 5.76471C15.6438 5.76471 15.25 5.34118 15.25 4.82353V3.88235H4.75V4.82353C4.75 5.34118 4.35625 5.76471 3.875 5.76471C3.39375 5.76471 3 5.34118 3 4.82353V2.94118C3 2.42353 3.39375 2 3.875 2ZM6.50068 11.4118C6.2338 11.4118 5.97218 11.2819 5.7998 11.0353C5.5093 10.6193 5.58805 10.0292 5.9748 9.71765L9.4748 6.89412C9.77755 6.64941 10.1941 6.64283 10.5029 6.87718L14.0029 9.52565C14.3984 9.82494 14.4938 10.4122 14.2156 10.8367C13.9373 11.2612 13.3922 11.3647 12.9967 11.0654L10.8728 9.45835C10.8744 9.48181 10.8753 9.50551 10.8753 9.52941V17.0588C10.8753 17.5784 10.4841 18 10.0003 18C9.51639 18 9.12526 17.5784 9.12526 17.0588V9.52941C9.12526 9.52934 9.12526 9.52927 9.12526 9.52921L7.0248 11.2235C6.8673 11.3506 6.68355 11.4118 6.50068 11.4118Z",
    },
  ],
]);

export default Upload;
